import React from 'react';

import H2 from 'apps/Pdf/components/common/H2';
import Spacer from 'apps/Pdf/components/common/Spacer';

import useGeneralStyles from 'apps/Pdf/styles/general';
import { Deposit } from 'stores/workflowStores/finances/depositsStore/model';
import { Currency } from 'enums';
import GeneralDeposit from './GeneralDeposit';

interface Props {
  currency: Currency;
  data?: Deposit[];
  annual?: boolean;
  actualInflation: number;
  original?: boolean;
}

const FutureDeposits: React.FC<Props> = ({ data, currency, annual, actualInflation, original }) => {
  const styles = useGeneralStyles();

  return data && data.length > 0 ? (
    <>
      <Spacer />
      <div className={styles.avoidPageBreak}>
        <H2>Plánované vklady v budoucnu</H2>
        {data &&
          data.length > 0 &&
          data.map((deposit) => {
            return (
              <GeneralDeposit
                deposit={deposit}
                currency={currency}
                annual={annual}
                actualInflation={actualInflation}
                key={`fd_${deposit.id}`}
                original={original}
              />
            );
          })}
      </div>
    </>
  ) : null;
};

export default FutureDeposits;
